import {$t} from "../../../helpers/translator";
import Menu from "../../../components/miscellaneous/Menu/Menu";
import {FaUsers, FaChartBar, FaUserMd, FaBookMedical, FaTools, FaCog, FaFileAlt, FaCalendarAlt} from 'react-icons/fa';
import machineWhite from '../../../assets/alma-icons/machineWhite.png'
import handleWhite from '../../../assets/alma-icons/handleWhite.png'
import {useSelector} from "react-redux";

const ClinicMenu = () => {
    const hasBookingEnabled = useSelector(state => state.auth?.clinic?.booking_enabled)

    const items = [
        {name: $t('global.menu.dashboard'), icon: <FaChartBar />, path: '/', pathIncludes: '/dashboard'},
        {name: $t('global.menu.patients'), icon: <FaUsers />, path: '/patients', pathIncludes: '/patient/'},
        {name: $t('global.menu.staff'), icon: <FaUserMd />, path: '/staff', pathIncludes: '/staff/'},
        {name: $t('global.menu.treatments'), icon: <FaBookMedical />, path: '/treatments', pathIncludes: '/treatments/'},
        {name: $t('global.menu.equipment'), icon: <FaCog />, path: null, children: [
            {name: $t('global.menu.platforms'), icon: machineWhite, path: '/equipment/platforms', pathIncludes: '/platform/'},
            {name: $t('global.menu.applicators'), icon: handleWhite, path: '/equipment/applicators', pathIncludes: '/applicator/'},
        ]},
        {name: $t('global.menu.reports'), icon: <FaFileAlt />, path: '/reports', pathIncludes: '/report/'},
        hasBookingEnabled && {name: 'Booking', icon: <FaCalendarAlt />, path: '/booking', pathIncludes: '/booking/'},
        {name: $t('global.menu.service'), icon: <FaTools />, path: '/service', exact: true},
    ]

    return (
        <Menu items={items} userType={2} />
    )
};

export default ClinicMenu;
